import { wine_and_book } from "./product_wine_and_book"; // ID : 6
import { lux_chess_set } from "./product_lux_chess_set"; // ID : 7
import { premium_hangers } from "./product_premium_hangers"; // ID : 8
import { tic_tac_toe } from "./product_tic_tac_toe"; // ID : 9
import { life_line_coasters } from "./product_life_line_coasters"; // ID : 10
import { new_year_decoration_set } from "./product_new_year_decoration_set"; // ID : 11
import { eterna } from "./product_eterna"; // ID: 12
import { senso } from "./product_senso"; // ID: 13
import { luce } from "./product_luce"; // ID: 14

export const _products = [
  luce,
  wine_and_book, 
  lux_chess_set, 
  premium_hangers, 
  tic_tac_toe, 
  eterna,
  senso,
  life_line_coasters, 
  new_year_decoration_set
];

export const _discount_actions = [
  // {
  //   from: "2024-06-18",
  //   to: "2024-07-01",
  //   product_ids: [6, 7, 8, 9, 10, 11],
  //   discount: 20,
  // },
];

export const getProducts = () => {
  // check if there is a discount action
  const today = new Date();
  const todayFormatted = today.toISOString().slice(0, 10);
  const discountAction = _discount_actions.find((action) => action.from <= todayFormatted && action.to >= todayFormatted);
  if (discountAction) {
    for (let i = 0; i < _products.length; i++) {
      const product = _products[i];
      if (discountAction.product_ids.includes(+product.product_id)) {
        product.product_discount = +discountAction.discount;
      }
    }
  }
  return _products;
};
